import router from './router'
import swal from 'sweetalert';
import {
	getLogout,
	getLoginUser
} from "@/api/index";
import { logout } from "@/utils/yawei";

router.beforeEach((to, from, next) => {
	// console.log("*****************进入路由拦截↓↓↓↓开始*****************");
	// console.log("to.path==> 要进入的路由", to.path);
	// console.log("from.path== 离开的路由>", from.path);
	let arr = ['/main/zscqzhfw/zyrzfwSb', '/main/zltszhfw/bzfw/apply', '/main/zxzxForm',
		'/main/zscqzhfw/zscqcsRecord', '/main/xwqyczfw/xqsq', '/main/xwqyczfw/zpxqfbForm',
		'/hkdt', //'/qygzs/index'
	];
	//获取要进入的路由
	const toPath = to.path;
	// 要进入的路由是否判断是否登录的路由
	const isLoginPath = arr.includes(toPath);
	if (isLoginPath) { //需要登录的路由，单独判断登录逻辑
		//获取localStorage中的登录信息
		//   let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser')) ;
		getSsessionLoginUser().then(res => {
			//从localStorage获取当前用户登录状态
			//获取当前用户	
			let ssessionLogin = res;
			let islogin=false;
			let user={};
			let ywFwjg={};
			if(res!=null){
				islogin = ssessionLogin.islogin;
				user = ssessionLogin.user;
				ywFwjg = ssessionLogin.ywFwjg;
			}
			// console.log("permission ssessionLogin==当前登录用户Session", ssessionLogin);
			// console.log("user==> 当前登用户", user);
			// console.log("islogin==> 是否已登录", islogin);
			//如果没有登录，直接跳到登录页面
			if (!islogin) {
				localStorage.clear();
				toLoginUrl();
			} else { //如果已经登录
			//----需要修改为recid
				/* 			  
				如果需要登录的路由，判断是否超期，如果超期，直接退出登录，提示登录超期 			  
				*/
				getLoginUser(user.ywFwjgRecid).then(response => { //判断是否登录超时
					// console.log("判断是否登录超时");
					///	// console.log(response);
					if (response.msg == '901') { //登录超时
						//	// console.log("超时");
						logout(user.ywFwjgRecid);
					} else {
						ssessionLogin.expireTime = response.data.expireTime;
						localStorage.setItem("ssessionLoginUser", JSON.stringify(ssessionLogin));
						// 如果进入路由是知识产权转让发布。单独判断
						if ('/main/zscqzhfw/zscqcsRecord' === toPath) {
							/*  
							   如果当前用户是个体户，直接放行 
							  如果当前用户是企业，判断是否异常名录或黑名单或信息是否完善
							  */
							if (user.ftype == '1') { //个体
								next();
							} else if (user.ftype == '2') { //企业
								judgementQy(user, next);
							} else {
								swal( "", "您的企业类型不明确，无法进行下一步操作！","warning",{button: false,timer: 1000});
							}
						} else if ('/qygzs/index' === toPath) { // 2、如果进入路由是企业工作室，单独判断
							/*
							  直接放行		        
							  */
							next();
						}else if('/main/zxzxForm'===toPath){//在线咨询的
							if (user.ftype === '1') { //个体
								swal( "", "您不是企业用户，不能操作此业务！","warning",{button: false,timer: 1000});
								setTimeout(function(){closeWindow()},1000);
							}else{
								/*
							  直接放行
							  */
								next();
							}
						}
						else { // 除企业工作室和知识产权转让发布的其他情况
							/* 如果是个体，直接拦截，
							如果是企业，判断是否黑名单 */
							// debugger
							if (user.ftype === '1') { //个体
								swal( "", "您不是企业用户，不能操作此业务！","warning",{button: false,timer: 1000});
							}else if(user.ftype==='2' && ywFwjg.entcat==='1'){//企业
								judgementQy(user, next);
							} else if (user.ftype === '2' && ywFwjg.entcat==='2') { //个体商户
								if (user.finishedInfo != null && user.finishedInfo == 'N') { //判断是否已经完善信息
									swal( "", "您的企业信息尚未完善，请前往企业工作室进行基本信息完善操作！","warning",{button: false,timer: 1000});
									next({path:'/qygzs/index'});
								}else{
									swal( "", "您不是企业用户，不能操作此业务！","warning",{button: false,timer: 1000});
								}
							} else {
								swal( "", "您的企业类型不明确，无法进行下一步操作！","warning",{button: false,timer: 1000});
							}
						}
					}
				});
			}
		})
	} else { //不要需要登录的路由，直接进入、
		getSsessionLoginUser().then(res => {
			//从localStorage获取当前用户登录状态
			//获取当前用户
			let ssessionLogin = res;
			if (res == null) {
				next();
			} else {
				let user = res.user;
				/*
				如果需要登录的路由，判断是否超期，如果超期，直接退出登录，提示登录超期
				*/

				getLoginUser(user.ywFwjgRecid).then(response => { //判断是否登录超时

					if (response.msg == '901') {
						logout(user.ywFwjgRecid);
					} else {
						ssessionLogin.expireTime = response.data.expireTime;
						localStorage.setItem("ssessionLoginUser", JSON.stringify(ssessionLogin));
					}
				})

			}
			next();
		})
		// console.log("permission 不需要登录的路由，直接进入、",to.path);
		// next();
	}
	// console.log("*****************进入路由拦截↑↑↑↑结束*****************");
});

const closeWindow = function(){
	var userAgent = navigator.userAgent;
	if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
		window.location.href="about:blank";
		window.close();
	} else {
		window.opener = null;
		window.open("", "_self");
		window.close();
	}
}


const toLoginUrl = function() {
	let url =
		"https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket";
	window.location.href = url;
}
const judgementQy = function(user, next) {
	// console.log("judgementQy---------------");
	if (user.isWhEnt != null && user.isWhEnt == 'N') { //判断是否是威海市企业
		swal( "", "你的企业非威海市企业，暂时不能进行此操作！","warning",{button: false,timer: 1000});
	} else if (user.isBlackList != null && user.isBlackList == 'Y') {
		swal( "", "您的企业属于严重违法失信或异常状态，暂时不能进行此操作！","warning",{button: false,timer: 1000});
	} else if (user.finishedInfo != null && user.finishedInfo == 'N') { //判断是否已经完善信息
		swal( "", "您的企业信息尚未完善，请前往企业工作室进行基本信息完善操作！","warning",{button: false,timer: 1000});
		next({path:'/qygzs/index'})
	} else {
		next()
	}
}
const getSsessionLoginUser = function() {
	return new Promise((resolve, reject) => {
		//let ssessionLoginUser = {"token":"8c0ea4d4dc7a681ec6e9c068f92729ed","loginTime":1743064817710,"expireTime":1743066617710,"ipaddr":null,"loginLocation":null,"browser":null,"os":null,"permissions":null,"user":{"uuid":"142767912","realName":"孙平","isauthuser":"1","cartType":"111","cartId":"370633197012261327","tel":"13001658539","ftype":"2","corname":"威海顺通会计服务有限公司","cornumber":"91371000MA95018D8K","state":0,"isBlackList":"N","isWhEnt":"Y","finishedInfo":"Y","county":"371020","countyCh":"高区","ywFwjgRecid":"7446522257fa445fb8d52fa7b93b1595"},"ywFwjg":{"recid":"7446522257fa445fb8d52fa7b93b1595","pripid":"3710000000220210924BTTFG","name":"威海顺通会计服务有限公司","uniscid":"91371000MA95018D8K","dom":"乳山市大孤山镇吴家沟村","llr":"李四666","llrtel":"15311432453","llrphone":"86237928","type":"00350087310f439daa96aa3025a6c06d","fwlmStatus":"1","shStatus":"2","zcTime":null,"deleteStatus":"N","synopsis":"asdfdsaf","website":null,"createBy":null,"createTime":"2021-11-20 00:00:00","updateBy":"孔霞","updateTime":"2023-02-09 00:00:00","zcsjStartTime":null,"zcsjEntTime":null,"cxReason":null,"userType":"2","loginName":"威海顺通会计服务有限公司","uuid":"142767912","lastLoginTime":null,"isBlack":"N","loginStatus":"1","loginTime":1743064817759,"county":"371020","countyCh":"高区","deptId":51,"deptCode":"37100031","cardType":null,"cardNumber":null,"entcat":"1","isFinishEdInfo":null,"opIdea":null,"ywAuditStatus":"4","ywSaveStatus":"Y","ywDelStatus":"N"},"enabled":true,"islogin":true}
		resolve(JSON.parse(localStorage.getItem('ssessionLoginUser')))
		// resolve(null)
	})
}
